'use client'

import { usePathname } from 'next/navigation'
import { SiteHeader } from '@/components/site-header'
import { SiteFooter } from '@/components/site-footer'

const HIDE_CHROME_ROUTES = ['/asistente-kuma']

export function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()

  const hideChrome = HIDE_CHROME_ROUTES.some(
    route => pathname === route || pathname.startsWith(`${route}/`)
  )

  return (
    <div className='relative flex min-h-screen flex-col'>
      {!hideChrome && <SiteHeader />}
      <main className='flex-1'>{children}</main>
      {!hideChrome && <SiteFooter />}
    </div>
  )
}
